import { useForm } from 'react-hook-form';
import '../Styles/ConfigureRewardPoints.scss';
import TextField from '@mui/material/TextField';
import {
    Typography,
    Grid,
    Button,
    Modal,
    Box,
    Autocomplete,
    FormLabel,
    FormControlLabel,
    Checkbox,
    Switch,
} from '@mui/material';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { NumericFormat } from 'react-number-format';
import { useState } from 'react';
function ConfigureRewardPoints() {
    // const { register, handleSubmit } = useForm();
    // const onSubmit = (data) => {
    //     console.log(data);
    // };

    const style = {
        position: 'absolute',
        top: '50%',
        // overflow: 'scroll',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60vw',
        height: '600px',
        bgcolor: 'background.paper',
        boxShadow: 24,
        pt: 2,
        px: 4,
        pb: 3,
        borderRadius: '5px',
    };

    const [formData, setFormData] = useState({
        address: '', // địa chỉ chi tiết
        email: '', // email
        name: '', // tên công ty
        shortName: '', // tên viết tắt
        representativeName: '', // người đại diện
        taxCode: '', // mã số thuế
        phone: '', // sdt
        provinceCode: '', // tỉnh
        districtCode: '', // huyện
        wardCode: '', // xã
        status: 2, // trạng thái
    });
    const [status, setStatus] = useState(true);
    const [open, setOpen] = useState(true);
    const handleOnSubmit = () => {};
    const [isChecked, setIsChecked] = useState(true);

    const handleClose = () => {
        setOpen(false);
    };

    // change trang thái

    const handleChangeStatus = (event) => {
        setIsChecked(event.target.checked);
    };
    return (
        <Modal open={open} aria-labelledby='child-modal-title' aria-describedby='child-modal-description'>
            <Box sx={{ ...style }}>
                <ValidatorForm onSubmit={handleOnSubmit} className='loyalty-config-form'>
                    <Typography id='child-modal-title' variant='h6' gutterBottom>
                        Cấu hình tích điểm thưởng
                    </Typography>
                    <div className='body-point'>
                        {' '}
                        <table>
                            <tbody>
                                <tr>
                                    <td>Trạng thái cấu hình</td>
                                    <td style={{ display: 'flex', alignItems: 'center' }}>
                                        Trạng thái đang được
                                        <FormControlLabel
                                            value='start'
                                            control={
                                                <Switch
                                                    color='primary'
                                                    checked={isChecked}
                                                    onChange={handleChangeStatus}
                                                />
                                            }
                                            label={isChecked ? 'BẬT' : 'TẮT'}
                                            labelPlacement='start'
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Tỷ lệ quy đổi điểm thưởng</td>
                                    <td>
                                        <Grid item xs={12} sm={6} style={{ display: 'flex', alignItems: 'center' }}>
                                            <TextField
                                                style={{ width: '100px' }}
                                                id='standard-basic'
                                                label=''
                                                variant='standard'
                                            />
                                            <span
                                                style={{
                                                    padding: '5px 10px',
                                                    margin: '0 10px',
                                                    backgroundColor: '#4CAF50',
                                                    color: '#fff',
                                                    borderRadius: '3px',
                                                }}
                                            >
                                                VND
                                            </span>
                                            = 1 điểm thưởng
                                            <span style={{ marginLeft: '20px', display: 'flex', alignItems: 'center' }}>
                                                Tối đa
                                                <TextField
                                                    style={{ width: '100px', margin: '0 10px' }}
                                                    id='standard-basic'
                                                    label=''
                                                    variant='standard'
                                                />
                                                điểm thưởng
                                            </span>
                                        </Grid>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        <input type='checkbox' />
                                        <span>Tích điểm cho tổng tiền hóa đơn bao gồm cả phí</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Điều kiện tích điểm</td>
                                    <td style={{ display: 'flex', alignItems: 'center' }}>
                                        <TextField
                                            id='standard-basic'
                                            style={{ width: '250px', marginBottom: '20px' }}
                                            label='Tổng tiền hoá đơn đạt tối thiểu'
                                            variant='standard'
                                        />
                                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                                            <FormControlLabel
                                                control={<Checkbox />}
                                                label='Tổng tiền hóa đơn bao gồm cả phí'
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Không tích điểm với</td>
                                    <td style={{ display: 'flex', flexDirection: 'column' }}>
                                        <FormControlLabel
                                            control={<Checkbox />}
                                            label='Không tích điểm cho hóa đơn có sản phẩm giảm giá'
                                        />
                                        <FormControlLabel
                                            control={<Checkbox />}
                                            label='Không tích điểm cho hóa đơn có sản phẩm áp dụng voucher'
                                        />
                                        <FormControlLabel
                                            control={<Checkbox />}
                                            label='Không tích điểm cho hóa đơn có tổng bill giảm giá'
                                        />
                                        <FormControlLabel
                                            control={<Checkbox />}
                                            label='Không tích điểm cho hóa đơn có tổng bill áp dụng voucher'
                                        />
                                        <FormControlLabel
                                            control={<Checkbox />}
                                            label='Không tích điểm cho hóa đơn thanh toán bằng điểm thưởng'
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <Grid item xs={12} sm={12} className='mt-4 d-flex justify-content-end'>
                        <Button className='mr-2' variant='contained' color='error' onClick={handleClose}>
                            Hủy
                        </Button>
                        <Button type='submit' variant='contained' color='primary'>
                            Lưu
                        </Button>
                    </Grid>
                </ValidatorForm>
            </Box>
        </Modal>
    );
}

export default ConfigureRewardPoints;
